module.exports = __webpack_public_path__ + "img/cww_09.ac0eb819.jpg";